var config = {
	// java主站接口
	// 根据构建环境自动切换：npm run dev(开发) / npm run build(生产)
	baseUrl: function() {
		if (process.env.NODE_ENV === 'production') {
			// 生产构建（npm run build）→ 华为云正式服务器
			return "https://app.mtr.xingshantech.cn";
		}
		else if (process.env.NODE_ENV === 'development') {
			// 开发模式（npm run dev）→ 本地后端
			return "http://localhost:8080";
		}
		else {
			// 其他环境（如 testing）→ 华为云测试服务器
			return "http://175.178.26.251:20088";
		}
	}
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/utils/config.js